import { useSelector } from 'react-redux';
import Icon, { ICON_WE_SPIN } from '~/components/icon/index.js';
import useTranslations from '../../../translation/use-translations';
import LinkList from '../../../misc/link-list.js';
import { selectIsBlockedStreamer, selectIsStreamer } from '../ducks/we-spin-dashboard-duck.js';
import { ROUTE_ACCOUNT_WE_SPIN_DASHBOARD } from '..';
import { WE_SPIN_ACCOUNT_TEXT_KEYS } from '../constants/we-spin-text-keys.js';
import { WE_SPIN_DASHBOARD_ACCOUNT_LINKLIST_DATA_AT } from '../constants/we-spin-data-at-attributes.js';

const WeSpinLineIcon = () => <Icon type={ICON_WE_SPIN} />;

const WeSpinDashBoardAccountLinkList = ({ className = '' }) => {
	const isStreamer = useSelector(selectIsStreamer) || false;
	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_ACCOUNT_TEXT_KEYS);
	const isBlockedStreamer = useSelector(selectIsBlockedStreamer);

	return (
		isStreamer &&
		!isBlockedStreamer &&
		!isLoadingTranslations && (
			<ul className="link-list">
				<LinkList
					className={className}
					to={ROUTE_ACCOUNT_WE_SPIN_DASHBOARD}
					PrimaryIcon={WeSpinLineIcon}
					title={tr.WE_SPIN_ACCOUNT_DASHBOARD_TITLE}
					dataAt={WE_SPIN_DASHBOARD_ACCOUNT_LINKLIST_DATA_AT}
				/>
			</ul>
		)
	);
};

export default WeSpinDashBoardAccountLinkList;
